import React, { useEffect } from "react"

import { Link } from "gatsby"
import { Col, Row } from "react-bootstrap"

import Cross from "../../images/icons/wdn-black-cross.jpg"

const SavedSearch = ({ search, handleModalHide }) => {
  const deleteSavedSearch = id => {
    handleModalHide(1, id)
  }

  useEffect(() => {}, [search])
  return (
    <>
      {search.map(search => {
        return (
          <Row key={search.id} className="saved-search-list">
            <Col xs={10}>
              <Link to={"/search-candidates" + search.keywords}>
                {search.name ? search.name : `Search History ${search.id}`}
              </Link>
            </Col>
            <Col xs={2} className={"text-right mb-2 pr-3"}>
              <button
                onClick={() => deleteSavedSearch(search.id)}
                className="img-cross no-outline no-border no-background"
              >
                <img src={Cross} alt="" />
              </button>
            </Col>
          </Row>
        )
      })}
    </>
  )
}

export default SavedSearch
